<template>
  <div>
    <div @click="showTeamInfo(entry?.team.id)" class="cursor-point link-content">
      <Breadcrumbs main="Турниры" :title=" 'Команда: '+ entry?.team?.name || ''">
      </Breadcrumbs>
    </div>
    <div>
      <b-modal centered id="modal-tournamentEntry" title="Сообщение" v-model="show">
        <p>
          Язык команды
          <b-form-select v-model="selectedRejectedLang" :options="languages"/>
          <b-alert :show="!selectedRejectedLang" class="mt-2">
            У командира не был установлен язык по умолчанию.
            Пожалуйста, выберите сами язык для отправки сообщения отклонения.
          </b-alert>
        </p>
        <p v-if="rejectedMessages[selectedRejectedLang]">
          Выбрать шаблон ответа
          <b-form-select v-model="selectedRejectedMessages"
                         :options="rejectedMessages[selectedRejectedLang]"/>
        </p>
        <p>
          Причина отклонения
          <b-textarea v-model="entry.reject_description" rows="8"/>
        </p>
        <template #modal-footer>
          <div>
            <b-btn variant="primary"
                   :disabled="isLoadingChangedStatus"
                   class="mr-3"
                   @click="declineEntry(entry.reject_description)"
            >
              Подтвердить
            </b-btn>
            <b-btn variant="danger"
                   :disabled="isLoadingChangedStatus"
                   @click="show=false"
            >
              Отмена
            </b-btn>
          </div>
        </template>
      </b-modal>
      <Modal name="UserDocuments"
             title="Верификация документов"
             v-model="isShowDocsModal"
             :size="'lg'"
             :params="{ userDocuments: userDocumentList,
                      isLoadingDocs: isLoadedUserDocs,
                      error: errorText}"/>
    </div>
    <div class="container">
      <div class="card p-2" style="overflow-x: auto">
        <div class="team-header">
          <div class="team-avatar-wrapper">
            <router-link :to="`/teams/${entry.team?.id}`" class="team-avatar-link">
              <b-avatar
                  size="80"
                  :src="entry.team?.logo?.original_url || entry.team?.logo?.webp || entry.team?.logo?.small_webp || UserImagePug"
                  class="team-avatar"
              ></b-avatar>
              <div class="avatar-ring"></div>
            </router-link>
          </div>
          <div class="team-info">
            <router-link :to="`/teams/${entry.team?.id}`" class="team-info">
              <h2 class="team-name">{{ entry?.team?.name }}</h2>
            </router-link>
            <div class="team-meta">
      <span class="badge badge-pill badge-light">
        <i class="fas fa-users mr-1"></i>
        {{ entry.members?.length || 0 }} участников
      </span>
            </div>
          </div>
          <div v-if="showTeamIntegrity" class="team-integrity" :class="integrityClass">
            <span class="integrity-label">Порядочность команды</span>
            <template v-if="hasIntegrityData">
              <span class="integrity-value">{{ integrityPercent }}%</span>
              <span class="integrity-detail">{{ teamIntegrity.connected }} из {{ teamIntegrity.total }} матчей</span>
            </template>
            <template v-else>
              <span class="integrity-value integrity-value--empty">—</span>
              <span class="integrity-detail">нет данных</span>
            </template>
          </div>
        </div>
        <table class="table mt-3 mb-3">
          <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Аватар</th>
            <th scope="col">Имя</th>
            <th scope="col">Nickname</th>
            <th scope="col">ID</th>
            <th scope="col">Просмотр</th>
          </tr>
          </thead>
          <tbody>
          <template>
            <tr v-for="(member, id) in entry.members" :key="member.id">
              <th scope="row">
<!--                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                  <path-->
<!--                      d="M9.5 0C4.2617 0 0 4.2617 0 9.5C0 11.7942 0.817633 13.901 2.17677 15.5445C2.18025 15.5493 2.18057 15.5553 2.18437 15.5597C3.16572 16.7431 4.39818 17.6504 5.77157 18.2365C5.7874 18.2432 5.80292 18.2505 5.81875 18.2571C5.9299 18.304 6.04232 18.3474 6.15505 18.3898C6.19938 18.4066 6.24372 18.4237 6.28868 18.4398C6.3859 18.4746 6.48375 18.5076 6.58223 18.5392C6.64525 18.5595 6.70827 18.5795 6.77192 18.5985C6.859 18.6244 6.9464 18.6494 7.03443 18.6732C7.1117 18.6941 7.1896 18.7134 7.2675 18.7321C7.34635 18.7511 7.42552 18.7701 7.505 18.7869C7.59367 18.8059 7.68328 18.8227 7.77322 18.8391C7.84542 18.8524 7.9173 18.8664 7.99013 18.8781C8.08988 18.8942 8.19027 18.9069 8.29097 18.9199C8.35588 18.9281 8.42048 18.9376 8.48572 18.9446C8.59972 18.9566 8.71467 18.9652 8.82993 18.9731C8.88345 18.9769 8.93665 18.9826 8.99048 18.9854C9.15863 18.9949 9.32868 19 9.5 19C9.67132 19 9.84137 18.9949 10.0101 18.9861C10.064 18.9832 10.1172 18.9775 10.1707 18.9737C10.286 18.9655 10.4009 18.9573 10.5149 18.9452C10.5802 18.9382 10.6447 18.9287 10.7097 18.9205C10.8104 18.9075 10.9108 18.8949 11.0105 18.8787C11.083 18.867 11.1552 18.8531 11.2274 18.8398C11.317 18.8233 11.4066 18.8065 11.4956 18.7875C11.5751 18.7704 11.654 18.7517 11.7331 18.7327C11.811 18.7137 11.8889 18.6944 11.9662 18.6738C12.0542 18.6504 12.1416 18.6251 12.2287 18.5991C12.2924 18.5801 12.3554 18.5602 12.4184 18.5399C12.5169 18.5082 12.6147 18.4753 12.712 18.4405C12.7566 18.4243 12.8009 18.4072 12.8456 18.3904C12.9586 18.348 13.0707 18.3043 13.1819 18.2577C13.1977 18.2511 13.2132 18.2438 13.2291 18.2372C14.6021 17.651 15.8349 16.7437 16.8163 15.5604C16.8201 15.5559 16.8204 15.5496 16.8239 15.5452C18.1824 13.901 19 11.7942 19 9.5C19 4.2617 14.7383 0 9.5 0ZM13.3497 17.4863C13.345 17.4886 13.3405 17.4911 13.3358 17.4933C13.2227 17.5478 13.1078 17.5991 12.9919 17.6491C12.9656 17.6602 12.9396 17.6716 12.9133 17.6827C12.812 17.7251 12.7094 17.7653 12.6062 17.8039C12.5631 17.8201 12.5201 17.8359 12.4767 17.8511C12.3851 17.8838 12.2933 17.9151 12.2005 17.9449C12.1429 17.9632 12.0849 17.9806 12.027 17.9977C11.9447 18.0224 11.862 18.0462 11.7784 18.0684C11.7081 18.087 11.6372 18.1041 11.5663 18.1209C11.4918 18.1387 11.4177 18.1567 11.3427 18.1726C11.2607 18.19 11.178 18.2048 11.0957 18.2197C11.0289 18.2321 10.9624 18.2451 10.8949 18.2558C10.8021 18.2704 10.7084 18.2821 10.615 18.2938C10.5558 18.3014 10.4969 18.3103 10.437 18.3166C10.3303 18.328 10.2226 18.3353 10.1153 18.3429C10.0675 18.3461 10.02 18.3515 9.97152 18.354C9.81477 18.3622 9.6577 18.3667 9.5 18.3667C9.3423 18.3667 9.18523 18.3622 9.0288 18.354C8.98067 18.3515 8.93317 18.3464 8.88503 18.3429C8.77737 18.3356 8.67002 18.328 8.5633 18.3166C8.50345 18.3103 8.44455 18.3014 8.38533 18.2938C8.29192 18.2821 8.19818 18.2704 8.1054 18.2558C8.03795 18.2451 7.97145 18.2321 7.90463 18.2197C7.82198 18.2048 7.73933 18.1896 7.65763 18.1726C7.58258 18.1567 7.50817 18.1387 7.43407 18.1209C7.36313 18.1038 7.2922 18.087 7.2219 18.0684C7.13862 18.0462 7.05565 18.0221 6.97332 17.9977C6.91537 17.9806 6.85742 17.9632 6.79978 17.9449C6.707 17.9151 6.61485 17.8838 6.52365 17.8511C6.48027 17.8356 6.4372 17.8198 6.39413 17.8039C6.2909 17.7653 6.1883 17.7251 6.08697 17.6827C6.06068 17.6719 6.03503 17.6605 6.00875 17.6494C5.89285 17.5997 5.7779 17.5481 5.66453 17.4936C5.65978 17.4914 5.65535 17.4892 5.6506 17.4867C4.54575 16.9521 3.56978 16.1934 2.7778 15.2719C3.38992 13.0178 5.12272 11.2008 7.35205 10.4779C7.39607 10.5048 7.44198 10.5288 7.48727 10.5542C7.51387 10.5691 7.54015 10.5849 7.56707 10.5991C7.66143 10.6492 7.75707 10.696 7.85492 10.7382C7.92997 10.7711 8.00755 10.799 8.08482 10.8275C8.10002 10.8329 8.11522 10.8389 8.13042 10.8442C8.55982 10.9962 9.0193 11.0833 9.5 11.0833C9.9807 11.0833 10.4402 10.9962 10.8693 10.8442C10.8845 10.8389 10.8997 10.8329 10.9149 10.8275C10.9921 10.799 11.0697 10.7711 11.1448 10.7382C11.2426 10.696 11.3383 10.6492 11.4326 10.5991C11.4595 10.5846 11.4858 10.5691 11.5124 10.5542C11.5577 10.5288 11.6039 10.5048 11.6483 10.4776C13.8776 11.2008 15.6101 13.0178 16.2225 15.2716C15.4305 16.1928 14.4546 16.9515 13.3497 17.4863ZM6.01667 6.96667C6.01667 5.04608 7.57942 3.48333 9.5 3.48333C11.4206 3.48333 12.9833 5.04608 12.9833 6.96667C12.9833 8.18837 12.3497 9.26345 11.3949 9.88538C11.2702 9.96645 11.1403 10.039 11.007 10.1023C10.9912 10.1099 10.9757 10.1178 10.9598 10.1251C10.0428 10.5422 8.95723 10.5422 8.04017 10.1251C8.02433 10.1178 8.0085 10.1099 7.99298 10.1023C7.85935 10.039 7.72983 9.96645 7.60507 9.88538C6.65032 9.26345 6.01667 8.18837 6.01667 6.96667ZM16.6975 14.669C15.9796 12.5492 14.3418 10.836 12.2493 10.0222C13.0862 9.2682 13.6167 8.1795 13.6167 6.96667C13.6167 4.6968 11.7699 2.85 9.5 2.85C7.23013 2.85 5.38333 4.6968 5.38333 6.96667C5.38333 8.1795 5.91375 9.2682 6.75102 10.0222C4.65848 10.8363 3.02068 12.5492 2.3028 14.669C1.25368 13.2126 0.633333 11.4279 0.633333 9.5C0.633333 4.61098 4.61098 0.633333 9.5 0.633333C14.389 0.633333 18.3667 4.61098 18.3667 9.5C18.3667 11.4279 17.7463 13.2126 16.6975 14.669Z"-->
<!--                      fill="black"></path>-->
<!--                </svg>-->
                {{ id + 1 }}
              </th>
              <td>
                <img class="rounded-circle"
                     :src="member.avatar?.webp || member.avatar?.small_webp || member.avatar?.original_url || UserImagePug"
                     :alt="'avatar: ' + member?.username" width="36" height="36">
              </td>
              <td>{{ member?.username || member?.full_name }}</td>
              <td @click="showUserInfo(member.id)" class="cursor-point link-content">
                {{ getFieldsMember(member)?.nick }}
              </td>
              <td>{{ getFieldsMember(member)?.id }}</td>
              <td>
                <b-button variant="primary" @click="getUserDocuments(member.id)">Документы</b-button>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
        <div class="d-flex justify-content-center pb-4"
             v-if="entry?.status?.code === 'await'"
        >
          <button class="btn btn-success mr-3 d-flex align-items-center"
                  :disabled="isLoadingChangedStatus"
                  @click.prevent="changeStatus(2)">
            <b-spinner v-if="isLoadingChangedStatus" small class="spinner-approve mr-2"></b-spinner>
            Принять
          </button>
          <button class="btn btn-danger mr-3"
                  :disabled="isLoadingChangedStatus"
                  @click.prevent="show = true">
            Отклонить
          </button>
        </div>
        <div id="show_entry_status" class="text-center  d-flex justify-content-center align-items-center">
          <div class="w-50 bg-info mb-4 rounded-lg">
            Статус заявки: {{ getStatus(entry?.status?.code) }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {TournamentEntryAdapterMixin} from '/src/mixins/Tournament/TournamentEntryAdapterMixin';
import {mapActions, mapState} from "vuex";
import {languages} from "@/constants/langs";
import Modal from '@/components/modals/index.vue'
import api from "@/api/api";
import {NameOfStatus} from '@/constants/Status/StatusesForEntries';
import UserImagePug from "@/assets/images/pugs/team.png";

export default {
  name: 'TournamentEntry',
  mixins: [TournamentEntryAdapterMixin],
  components: {Modal},
  data() {
    return {
      show: false,
      isShowDocsModal: false,
      memberId: null,
      selectedRejectedMessages: null,
      selectedRejectedLang: '',
      isLoadingChangedStatus: false,
      userDocumentList: [],
      isLoadedUserDocs: false,
      errorText: null,
    }
  },
  computed: {
    UserImagePug() {
      return UserImagePug
    },
    ...mapState({
      rejectedMessages: state => {
        const rejectedMessages = state.moduleTournamentEntries.rejectedMessages
        Object.keys(rejectedMessages).forEach((lang) => {
          rejectedMessages[lang] = rejectedMessages[lang].map((data) => ({text: data.short, value: data.message}))
        })
        return rejectedMessages
      }
    }),
    languages() {
      return languages.map(({shortcode, title}) => ({
        text: title,
        value: shortcode
      }))
    },
    teamIntegrity() {
      return this.entry?.team_integrity || null
    },
    // Показатель порядочности только для PUBG Mobile (в проекте спец-кейсится только 'mlbb').
    showTeamIntegrity() {
      return !!this.entry?.team?.id && this.entry?.tournament?.game?.slug !== 'mlbb'
    },
    hasIntegrityData() {
      return !!this.teamIntegrity
          && this.teamIntegrity.percent !== null
          && this.teamIntegrity.percent !== undefined
    },
    integrityPercent() {
      if (!this.hasIntegrityData) return null
      // Округляем до 2 знаков и убираем лишние нули (66.67, 66.6, 100).
      return Number(Number(this.teamIntegrity.percent).toFixed(2))
    },
    integrityClass() {
      if (!this.hasIntegrityData) return 'is-empty'
      if (this.integrityPercent >= 90) return 'is-good'
      if (this.integrityPercent >= 70) return 'is-warn'
      return 'is-bad'
    }
  },
  async mounted() {
    await this.showTournamentEntry({
      tournamentId: this.$route.params.tournamentId,
      entryId: this.$route.params.entryId,
    })
    await this.getTranslationMailing()
    this.selectedRejectedLang = this.entry?.author?.lang?.code || 'ru'
  },
  methods: {
    ...mapActions([
      'getTranslationMailing'
    ]),
    changeStatus() {
      if (this.isLoadingChangedStatus) return;
      this.isLoadingChangedStatus = true
      this.changeTournamentEntryStatus({
        entryId: this.entry.id,
        status: 2, // 2 accepted status 3 rejected status
      }).then((statusCode) => {
        if (statusCode === 200) {
          this.$router.push({'name': 'tournament_teams', params: {id: this.entry.tournament.id}})
          this.isLoadingChangedStatus = false
        }
      })
    },
    declineEntry(rejectDescription) {
      if (this.isLoadingChangedStatus) return;
      this.changeTournamentEntryStatus({
        entryId: this.entry.id,
        status: 3, // 2 accepted status 3 rejected status
        reject_description: rejectDescription
      }).then((statusCode) => {
        if (statusCode === 200) {
          this.$router.push({'name': 'tournament_teams', params: {id: this.entry.tournament.id}})
        }
      })
    },
    getStatus(status) {
      return NameOfStatus[status];
    },
    getUserDocuments(id) {
      this.memberId = id
      this.isShowDocsModal = true;
      (async () => {
        this.isLoadedUserDocs = true
        const response = await api.docs.showUserDocs(this.memberId)
            .catch((error) => {
              this.errorText = 'For view documents ' + error.response.data.message
            })
        this.userDocumentList = response.data.user_documents
        this.isLoadedUserDocs = false
      })()
      if (!this.isShowDocsModal) this.userDocumentList = []
    },
    getFieldsMember(member) {
      const game = this.getTournamentEntry.tournament.game
      const foundProfile = member.game_profiles.find(({game_id}) => game_id === game.id)
      if (foundProfile) {
        const fields = foundProfile.fields
        fields.id = fields[game.slug === 'mlbb' ? 'mlbb_id' : 'pubg_id']
        return fields
      }
      return {}
    },
    showUserInfo(userId) {
      const route = this.$router.resolve({name: 'user_info', params: {id: userId}})
      window.open(route.href, '_blank')
    },
    showTeamInfo(teamId) {
      this.$router.push({name: 'teams_info', params: {id: teamId}})
    },
  },
  watch: {
    selectedRejectedMessages(newValue) {
      this.entry.reject_description = newValue
    }
  }
}
</script>

<style scoped>
.link-content {
  color: #3250c3;
  text-decoration: underline;
}

.team-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
  padding: 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  margin-bottom: 24px;
  box-shadow: 0 10px 40px rgba(102, 126, 234, 0.3);
}

.team-avatar-wrapper {
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
}

.team-avatar {
  border: 4px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.avatar-ring {
  position: absolute;
  top: -6px;
  left: -6px;
  right: -6px;
  bottom: -6px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.05); opacity: 0.8; }
}

.team-info {
  color: white;
}

.team-name {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.team-meta .badge {
  font-size: 14px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.team-integrity {
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 150px;
  padding: 14px 20px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.team-integrity .integrity-label {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 4px;
}

.team-integrity .integrity-value {
  font-size: 30px;
  font-weight: 800;
  line-height: 1.1;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.team-integrity .integrity-value--empty {
  color: rgba(255, 255, 255, 0.7);
}

.team-integrity .integrity-detail {
  margin-top: 2px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
}

.team-integrity.is-good .integrity-value {
  color: #b7f7c8;
}

.team-integrity.is-warn .integrity-value {
  color: #ffe28a;
}

.team-integrity.is-bad .integrity-value {
  color: #ffc2bd;
}

@media (max-width: 575px) {
  .team-integrity {
    margin-left: 0;
    width: 100%;
  }
}
</style>
